/**
 * Personnel Transfer Checklist
 * Before transferring persons (crew/pilot)
 * Regulatory: WBC3 25.5-25.6
 */

export const PERSONNEL_TRANSFER_CHECKLIST = {
  id: 'personnel_transfer',
  name: 'Personnel Transfer',
  description: 'Before transferring persons',
  icon: 'Users',
  regulatory: 'WBC3 25.5-25.6',
  isCustomisable: true,
  items: [
    { id: 'pt_1', text: 'Weather and sea state within transfer limits', required: true },
    { id: 'pt_2', text: 'MOB recovery readiness confirmed', required: true },
    { id: 'pt_3', text: 'Transfer equipment rigged and secure', required: true },
    { id: 'pt_4', text: 'All transferring personnel wearing lifejackets', required: true },
    { id: 'pt_5', text: 'Communications established with receiving party', required: true },
    { id: 'pt_6', text: 'Crew briefed and lookout posted', required: true }
  ]
};
